import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import { DashboardContentProvider } from './provider';
import { DashboardDevices } from './components/devices';
import { AlarmDevices } from './components/alarm-devices';
import { SaveDashboardUISettings } from './save-button';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
export const Dashboard = memo(function Z3KDashboard() {
    const { dashboard_settings } = useAppSelector(select_ui_settings);
    const devices_key = useMemo(() => dashboard_settings?.devices?.map(({ id }) => id).join('-'), [dashboard_settings?.devices]);
    return (_jsxs(DashboardContentProvider, { children: [_jsxs(Box, { display: "flex", flexDirection: "column", height: "100%", children: [_jsx(AlarmDevices, {}), _jsx(DashboardDevices, {}, devices_key)] }), _jsx(SaveDashboardUISettings, {})] }));
});
